import React from 'react';
import './title.css';

const Header = ({ setActiveView }) => {
  return (
    <div className="header">
      <h1 onClick={() => setActiveView('tagManagement')}>Tag Management</h1>
      <h1 onClick={() => setActiveView('databaseImport')}>Database Import</h1>
      <h1 onClick={() => setActiveView('manageUsers')}>Manage Users</h1>
    </div>
  );
};

export default Header;